<template>
  <!-- 民办非业务活动表-->
  <div class="big_box4">
    <div class="top_title3">
      <h5>业务活动表（月报）</h5>
      <div class="bottom_font clearfix">
        <h6 class="left">纳税人名称：<span>{{comName}}</span></h6>
        <h6 class="center"><span>{{durationOfTaxTime}}</span></h6>
        <h6 class="right">
          <p>单位：元</p>
          <p>纳税人识别号：<span>{{taxNo}}</span></p>
        </h6>
      </div>
    </div>
    <table class="content" cellspacing="0">
      <tr class="top_bg">
        <td class="center" style="width:18%;" rowspan="2">项目</td>
        <td class="center" style="width:4%;" rowspan="2">行次</td>
        <td class="center" style="width:39%;" colspan="3">本月数</td>
        <td class="center" style="width:39%;" colspan="3">本年累计数</td>
      </tr>
      <tr class="top_bg">
        <td class="center" style="width:13%;">非限定性</td>
        <td class="center" style="width:13%;">限定性</td>
        <td class="center" style="width:13%;">合计</td>
        <td class="center" style="width:13%;">非限定性</td>
        <td class="center" style="width:13%;">限定性</td>
        <td class="center" style="width:13%;">合计</td>
      </tr>
    </table>
    <div class="fixed_box_table" :style="{height:contentStyleObj}">
      <table class="content" cellspacing="0">
        <tr>
          <td class="weight" style="width:18%;">一、收入</td>
          <td style="width:4%;"></td>
          <td style="width:13%;"></td>
          <td style="width:13%;"></td>
          <td style="width:13%;"></td>
          <td style="width:13%;"></td>
          <td style="width:13%;"></td>
          <td style="width:13%;"></td>
        </tr>

        <tr>
          <td class="left_k">其中：捐赠收入</td>
          <td class="center">1</td>
          <td><input type="text" v-model="list[1].qmyeZc"></td>
          <td><input type="text" v-model="list[1].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[1].qmyeQy"></td>
          <td><input type="text" v-model="list[1].ncyeQy"></td>
        </tr>
        <tr>
          <td class="left_k">会费收入</td>
          <td class="center">2</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>

        <tr>
          <td class="left_k">提供服务收入</td>
          <td class="center">3</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>

        <tr>
          <td class="left_k">商品销售收入</td>
          <td class="center">4</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>

        <tr>
          <td class="left_k">政府补助收入</td>
          <td class="center">5</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        <tr>
          <td class="left_k">投资收益</td>
          <td class="center">6</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        <tr>
          <td class="left_k">其他收入</td>
          <td class="center">7</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        <tr>
          <td class="weight">收入合计</td>
          <td class="center">8</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        
        <tr>
          <td class="weight">二、费用</td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr>
          <td class="weight">（一）业务活动成本</td>
          <td class="center">9</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        <tr>
          <td class="left_k">其中：</td>
          <td class="center">10</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        <tr>
          <td class="left_k">（二）管理费用</td>
          <td class="center">11</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        <tr>
          <td class="left_k">（三）筹资费用</td>
          <td class="center">12</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        <tr>
          <td class="weight">（四）其他费用</td>
          <td class="center">13</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        <tr>
          <td class="weight">费用合计</td>
          <td class="center">14</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        <tr>
          <td>三、限定性净资产转为非限定性净资产</td>
          <td class="center">15</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>
        <tr>
          <td>四、净资产变动额（若为净资产减少额，以“-”号填列）</td>
          <td class="center">16</td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeZc"></td>
          <td><input type="text" v-model="list[0].ncyeZc"></td>
          <td><input type="text" v-model="list[0].qmyeQy"></td>
          <td><input type="text" v-model="list[0].ncyeQy"></td>
        </tr>

      </table>
    </div>
    <div class="save_box">
      <el-button type="primary" size="mini" plain>保存</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'finance',
  components: { },
  data() {
    return {
      fullscreenLoading: false,
      durationOfTaxTime: '',
      list:[{"id":156,"kjMainId":14,"type":1,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":157,"kjMainId":14,"type":2,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":158,"kjMainId":14,"type":3,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":159,"kjMainId":14,"type":4,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":160,"kjMainId":14,"type":5,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":161,"kjMainId":14,"type":6,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":162,"kjMainId":14,"type":7,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":163,"kjMainId":14,"type":8,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":164,"kjMainId":14,"type":9,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":165,"kjMainId":14,"type":10,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":166,"kjMainId":14,"type":11,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":167,"kjMainId":14,"type":12,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":168,"kjMainId":14,"type":13,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":169,"kjMainId":14,"type":14,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":170,"kjMainId":14,"type":15,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":171,"kjMainId":14,"type":16,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":172,"kjMainId":14,"type":17,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":173,"kjMainId":14,"type":18,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":174,"kjMainId":14,"type":19,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":175,"kjMainId":14,"type":20,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":176,"kjMainId":14,"type":21,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":177,"kjMainId":14,"type":22,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":178,"kjMainId":14,"type":23,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":179,"kjMainId":14,"type":24,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":180,"kjMainId":14,"type":25,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":181,"kjMainId":14,"type":26,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":182,"kjMainId":14,"type":27,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":183,"kjMainId":14,"type":28,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":184,"kjMainId":14,"type":29,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":185,"kjMainId":14,"type":30,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0},{"id":186,"kjMainId":14,"type":31,"zcxmmc":"","qmyeZc":0,"ncyeZc":0,"qyxmmc":"","qmyeQy":0,"ncyeQy":0}],
      comName:this.$store.getters['user/comInfo'].comName,
      taxNo:this.$store.getters['user/comInfo'].taxNo,
      contentStyleObj:{}, //高度变化
    }
  },
  created() {
    // 获取窗口高度
    this.contentStyleObj=this.$getHeight(356)
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.save_box{
  margin: 0 auto;
  margin-top: 20px;
  text-align: center;
}
.content{
  // width: 2000px;
  width: 100%;
  margin: 0 auto;
  border:1px solid #c2c2c2;
  border-bottom: none;
  border-right: none;
  margin-top: 10px;
 
  span{
    line-height: 28px;
    font-size: 14px;
  }
  tr{
    padding: 0;
    margin: 0;
  }
  td{
    border-right:1px solid #c2c2c2;
    border-bottom:1px solid #c2c2c2;
    line-height: 28px;
    padding:0 6px;
    color: #333;
    font-size: 14px;
  }
  input{
    width: 100%;
    line-height: 28px;
    padding: 0 6px;
    font-size: 14px;
    padding-right:20px;
  }
}
.left_k{
  text-indent: 2em;
}
.left_b{
  text-indent: 4em;
}
.left_x{
  text-indent:5em;
}
.left_d{
  text-indent:8em;
}
.top_title3{
  width: 100%;
  margin: 0 auto;
  h5{
    font-size: 20px;
    color: #333;
    font-weight: 700;
    text-align: center;
  }
  .bottom_font{
    width: 100%;
    margin: 0 auto;
    margin-top: 10px;
    // position: relative;
    h6{
      float: left;
      width: 33.33%;
      font-size: 14px;
      color: #333;
      font-weight: normal;
      // position: absolute;
      // bottom: 0;
    }
    h6:nth-child(1){
      padding-top: 10px;
    }
    h6:nth-child(2){
      padding-top: 10px;
    }
  }
}
.center{
  text-align: center;
}
.left{
  text-align: left;
}
.right{
  text-align: right;
}
.weight{
  font-weight: 700;
}
.row_box{
  border-bottom: 1px solid #eee;
}
.big_box4{
  width: 98%;
  // padding: 40px;
  background: #fff;
  // box-shadow: 0 2px 10px #ddd;
  margin: 0 auto;
  box-sizing: border-box;
}
.qsly{
  margin: 4px 5px 0 0;
  float: right;
  color: #666;
  // border: 0;
  // background: #fff;
  cursor: pointer;
}
</style>
